import React from 'react';
import { makeStyles } from 'tss-react/mui';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

const useStyles = makeStyles()((theme) => ({
  title: {
    ...theme.typography.subtitle2,
    color: theme.palette.primary.main,
  },
  textDisabled: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
  },
}));

const TermsOfUseTop = () => {
  const { classes } = useStyles();
  return (
    <div>
      <p>
        <strong>Last Updated</strong>: 06.29.2021
      </p>

      <p
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        className={classes.title}
      >
        Federation CJA and Jewish Federation of Metropolitan Detroit welcome you to JLIVE.
      </p>

      <p
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        className={classes.textDisabled}
      >
        These Terms and Conditions, including the JLIVE Privacy Policy found here (“<strong>Privacy Policy</strong>”)
        and any other applicable policies, guidelines or terms posted on our Site or otherwise made available through
        the Services from time to time, which are hereby incorporated by reference as if fully restated herein, apply to
        and govern your use of the JLIVE website and app (collectively, the “<strong>Site</strong>”) and any and all
        services and software that JLIVE offers through the Site (collectively, together with the Site, the “
        <strong>Services</strong>”) and your relationship and interaction with JLIVE (the “
        <strong>Terms and Conditions</strong>”).
      </p>

      <p
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        className={classes.textDisabled}
      >
        PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY. THESE TERMS AND CONDITIONS INCLUDE OR INCORPORATE PROVISIONS
        SUCH AS LIMITATIONS OF LIABILITY, DISPUTE RESOLUTION AND OTHER PROVISIONS THAT AFFECT YOUR LEGAL RIGHTS,
        REMEDIES AND OBLIGATIONS. YOU ACKNOWLEDGE AND AGREE THAT WE MAY REVISE OR CHANGE THESE TERMS AND CONDITIONS AT
        ANY TIME, WITHOUT NOTICE TO YOU, AND YOU AGREE THAT YOU WILL BE BOUND BY THE PROVISIONS OF THESE TERMS AND
        CONDITIONS AS THEY APPEAR ON THE SITE OR SERVICES AT THE TIME YOU ACCESS THE SITE OR SERVICES. BECAUSE THE
        PROVISIONS IN THESE TERMS AND CONDITIONS MAY CHANGE, YOU ARE ENCOURAGED TO REFER BACK OFTEN TO THESE TERMS AND
        CONDITIONS.
      </p>
    </div>
  );
};

export default TermsOfUseTop;
